import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../assets/css/PollView.css';
import { baseurl } from '../utility/helper';

const EditAdmin = () => {
  const [chapters, setChapters] = useState([]);
  const [roles, setRoles] = useState([]);
  const location = useLocation();
  const { adminId, edit } = location.state || {};
  const [isEditing, setIsEditing] = useState(edit);
  const [profileImage, setProfileImage] = useState(null);
  const [formData, setFormData] = useState({
    chapter_id: '',
    name: '',
    email: '',
    mobileno: '',
    role_name: '',
    designation:'',
    role_id: '',
  });

  const handleImageChange = (e) => {
    setProfileImage(e.target.files[0]);
  };

  // Fetch admin details
  const fetchAdminData = () => {
    if (adminId) {
      axios.get(`${baseurl}/admin/listadmin/${adminId}`)
        .then(response => {
          setFormData(response.data);
          setProfileImage(response.data.profile_img);
        })
        .catch(error => {
          console.error('Error fetching admin data:', error);
        });
    }
  };

  // Fetch chapters list
  const fetchChapters = () => {
    axios.get(`${baseurl}/admin/chapters`)
      .then(response => {
        setChapters(response.data);
      })
      .catch(error => {
        console.error('Error fetching chapters:', error);
      });
  };

  // Fetch roles list
  const fetchRoles = () => {
    axios.get(`${baseurl}/admin/userrole`)
      .then(response => {
        setRoles(response.data);
      })
      .catch(error => {
        console.error('Error fetching roles:', error);
      });
  };

  useEffect(() => {
    fetchAdminData();
    fetchChapters();
    fetchRoles();
  }, [adminId]);

  const handleEditMode = () => {
    setIsEditing(true);
  };

  const handleClose = () => {
    setIsEditing(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();

    Object.keys(formData).forEach(key => {
      data.append(key, formData[key]);
    });

    if (profileImage) {
      data.append("profilePicture", profileImage);
    }

    axios.put(`${baseurl}/admin/listadmin/${adminId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(response => {
      console.log('Data saved:', response.data);
      setIsEditing(false);
      fetchAdminData();
    })
    .catch(error => {
      console.error('Error saving data:', error);

    if (error.response && error.response.data) {
      if (error.response.data.code === '23505') {
        alert("Email already exists. Please use a different email.");
      } else {
        alert(error.response.data.message || "Something went wrong!");
      }
    } else {
      alert("Server error. Please try again.");
    }
    });
  };

  return (
    <div className="container mt-4">
      <div className="col-md-12 text-end">
         <button className="cl-back-btn " onClick={() => window.history.back()} style={{ float : 'left'}}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
            Back
          </button>
        {!isEditing && <button className="btn btn-primary" onClick={handleEditMode}>Edit</button>}
      </div>
      <form onSubmit={handleSubmit}>
        <div className="profile-section" style={{ marginTop: '20px' }}>
          <center><h3><b>View Admin Details</b></h3></center>

          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <label className="form-label" htmlFor="chapter">Select Chapter:</label>
                <select
                  className="form-select"
                  id="chapter_id"
                  name="chapter_id"
                  value={formData.chapter_id}
                  onChange={handleChange}
                  disabled={!isEditing}
                >
                  <option value="">Select a Chapter</option>
                  {chapters.map((chapter) => (
                    <option key={chapter.chapter_id} value={chapter.chapter_id}>
                      {chapter.chapter_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label" htmlFor="name">Admin Name:</label>
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>

              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label className="form-label" htmlFor="email">Admin Email:</label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>

              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label className="form-label" htmlFor="mobileno">Admin Mobile No:</label>
                <input
                  type="text"
                  className="form-control"
                  id="mobileno"
                  name="mobileno"
                  value={formData.mobileno}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>

              <div className="col-md-6"  style={{ paddingTop: '20px' }}>
                <label className="form-label">Admin Designation:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Designation For eg: Chairman, President etc.."
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  disabled={!isEditing}
                />
              </div>


              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label className="form-label" htmlFor="role_id">Select User Role:</label>
                <select
                  className="form-select"
                  id="role_id"
                  name="role_id"  // Correct name attribute
                  value={formData.role_id}  // Ensure role_id is correctly assigned
                  onChange={handleChange}
                  disabled={!isEditing}
                >
                  <option value="">Select a Role</option>
                  {roles.map((role) => (
                    <option key={role.role_id} value={role.role_id}>
                      {role.role_name}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="text-center" style={{marginBottom:'20px', marginTop:'20px'}}>
                {profileImage && typeof profileImage === "string" ? (
                  <img
                    src={`${profileImage}`}
                    alt="profile"
                    style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "10%",
                      objectFit: "cover"
                    }}
                  />
                ) : profileImage ? (
                  <img
                    src={URL.createObjectURL(profileImage)}
                    alt="preview"
                    style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "50%",
                      objectFit: "cover"
                    }}
                  />
                ) : null}

                {isEditing && (
                  <div style={{marginTop:'10px'}}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>

        {isEditing && (
          <div className="text-center" style={{ marginTop: '20px' }}>
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancel</button> &nbsp;
            <button type="submit" className="btn btn-primary">Save</button>
          </div>
        )}
      </form>
    </div>
  );
};

export default EditAdmin;
